export const CROPS = [
  'Pepper Red',
  'Pepper Yellow',
  'Pepper Orange'
]

export const VARIETIES = {
  'Pepper Red': [
    '1006', '10213 (10861)', '109', '1112', '1157', '11258', '1204', '163-35', '1672', '213', '2227',
    '3001_SIDS', '308 Tarsis', '3085', '3493', '39590', '39611', '5768', '6106', '6174', '716_GEDERA',
    '718', '7387', '815_MATCH', '83823', '882_MATCH', '9908', 'Alabama', 'Allison', 'Argaman', 'Armada',
    'Avante', 'B-19', 'BAYERN', 'BERESHIT_YONI', 'BR1089', 'BSB 405', 'BUTAROS', 'Bily', 'Botaros', 'Bungee',
    'Butrus', 'CANON 7158', 'CS22-11', 'Caliber', 'Calibero', 'Canon', 'Caravaggio', 'Cassiano', 'E200B-0254',
    'EFAL', 'EFEE', 'Eden 748', 'Eden 944', 'Esposo', 'F20B0299', 'FAVIA 044', 'FAVIA 108', 'Fabris', 'Fascinated',
    'Felicitas', 'France', 'GODZILA', 'GOLYAT', 'Galiano', 'Gilad', 'Gina', 'Heion', 'IMPERIO', 'JORDI 1890',
    'KRIM', 'Kaimek', 'Kapya', 'Karnaf', 'Katela', 'Keesie', 'MACHTESH_815', 'MERKAVA 7455', 'MUAID_KOMODIS',
    'MAUID_TORNADO', 'Margarethe', 'Marletta', 'Melchor', 'Mika', 'Miko', 'Mauyad 28', 'Mauyad 29', 'NOAM',
    'Nadia', 'Nesbitt', 'Netz 4005', 'OFEK 7445', 'Ocelot', 'Ocelot (Grafted)', 'Orange 9274', 'Origen 1414',
    'P006417', 'PTO-001', 'Palermo', 'Pitzia', 'Pompeo', 'RP001', 'R_P_1750', 'R_P_1786', 'R_P_1890', 'R_P_243',
    'R_P_705', 'R_P_7387', "Ra''am", 'Red 9278', 'Redline', 'Relampago', 'Riazor', 'Romance', 'SA-1123', 'SA-1449',
    'SAMCO_1742', 'SP004', 'Sobek', 'Sondela', 'Spray 304', 'Spray 306', 'Spray 307', 'Spray 309', 'Spray 312',
    'Strike', 'Subban', 'TOP 103', 'TOP 107', 'TOP 141', 'TOP 38', 'TZALAF', 'Talking reds', 'Tinder', 'Top 142',
    'Top 158', 'Tribeka', 'Triple 5', 'V08384', 'VIPER', 'Viper (Grafted)', 'YAZIR', 'YONI_3002', 'Yahav 7451',
    'Yevul', 'Zamboni'
  ],
  'Pepper Yellow': [
    'DROP_713', '10013', '1104', '1108', '223-Sabor', '254', '35-245', '35244',
    '35246', '721702', '7862', 'BY1145', 'BYE_103', 'BYG', 'Bambuca', 'Barreto', 'Baselga',
    'CLY-001', 'Carrasco', 'Cartujo', 'Conga', 'Coronado', 'Cozumel', 'DUNE 302', 'Delux',
    'Deniro', 'Dicaprio', 'Dinamo', 'E20B.0227 F1', 'E20B.10420 F1', 'Eurix', 'Gitit', 'HILA',
    'Hattrick', 'Jeremy', 'Kitrino', 'LIRI', 'Leia 8384', 'Lemonchelo', 'Lorenss', 'NADYA 6123',
    'NADYA 6126', 'Nadia', 'Nil', 'Ornit 4001', 'POLARIS', 'ROEI_52_10', 'Rialto', 'Rookie',
    'Sansiro', 'Sardinero', 'Seven', 'Shir', 'Sol', 'Song', 'Stephania', 'TAR Y8', 'TOP 79',
    'Tallante', 'Tirza', 'Top 162', 'YONI_4001', 'YONI_4002', 'Y_P_1008', 'Y_P_1127', 'Yael'
  ],
  'Pepper Orange': [
    '10135', '351176', '351177', '6101 Miranda', '6883', '719', '9000', '9006',
    'ARANCIA', 'Arenasia', 'Arnesa', 'BO1176', 'Berkley', 'Colorte', 'Dinur', 'E200B-0254',
    'E20B.10419 F1', 'F20B0299', 'GALAXY 019', 'Gilion', 'Icaza', 'JORDEN 71020', 'Jack Miller', 'LIAD',
    'Mango', 'Meridia', 'Milena', 'Miller', 'Mozart', 'NETA', 'Nadia', 'OR', 'O_P_9014', 'Orangela',
    'Orangely', 'Orbit', 'Orenji', 'Original', 'P006417', 'Palriho', 'Prosperity', 'Sympathy',
    'TAMAYO', 'TAVOR', 'Top 164', 'V08384', 'Volcano', 'ZOHAR'
  ]
}
